module.exports = __webpack_public_path__ + "img/MasterCard_SecureCode.7d5963f0.webp";